import { render } from "./hotel_index.vue?vue&type=template&id=536b0fcc"
import script from "./hotel_index.vue?vue&type=script&lang=js"
export * from "./hotel_index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__